import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http'
import { Subject, BehaviorSubject } from 'rxjs';
import {interval, Observable, of, timer} from 'rxjs';


import * as moment from 'moment';
// ATTENZIONE, 23/05/2023 Commento per provare a compilare dopo upgrade v15
// import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

export class Boat {
  dev_sn: string;
  dev_name: string;
  name: string;
  sailn: string;
  owner: string;
  class:string;
  visible: boolean;
  fullTrackvisible: boolean;
  tcc: number;  
  gph: number;
  displayOrder: number;
  cog: number;
  sog: number;
  vmg: number;
  nav_status: number;
  nav_status_text: string;
  nav_dtg_tot: number;
  nav_next_wp_lat: number;
  nav_next_wp_lon: number;
  nav_next_wp_name: string;
  nav_next_wp_dtg: number;
  nav_next_wp_ttg: number;
  nav_ttg_tot: number;
  nav_ttg_tot_text: string;
  nav_eta_epoch: number;
  nav_eta_text: string;
  nav_toa_epoch: number;
  nav_toa_text: string;
  track_latlon: number[][];
  track_epoch: number[];
  last_msg_epoch?: number;
  last_msg_datetime?: string;
  iconColor?:string;
  iconColorInverted?:string;
  iconHtml?:string;
}

export class BoatLeaderBoard {
  boatId: number; 
  dev_sn: string;
  dev_name: string;
  name: string;
  class: string;
  sailn: string;
  iconColor: string;
  visible: boolean;
  fullTrackVisible: boolean;
  last_msg_epoch?: number;
  last_msg_datetime?: string;
  nav_status: number;
  nav_status_text: string;
  nav_dtg_tot: number;
  nav_ttg_tot: number;
  nav_ttg_tot_text: string;
  nav_eta_epoch: number;
  nav_eta_text: string;
  nav_toa_epoch: number;
  nav_toa_text: string;
  cog: number;
  sog: number;
  vmg: number;
  tcc: number;
  distanceSailed: number;
  startDateTime: string;
}

export class BoatLayer {
  marker: any;
  polyline: any;
}

export class Event {
  name: string;
  customer: string;
  description: string;
  location: string;
  website: string;
  begin: string;
  end:string;
  tracking_begin: string;
  tracking_end: string;
  trackinginterval: number;
  centerlatitude: string;
  centerlongitude: string;
  startzoom: string;
  markers : {  
    name: string;
    lat: number;
    lon: number;
    transitrange: number,
    nav_dtg:number
  } [] 
}

export class BoatClass {
  name: string;
  visible: boolean;
}


@Injectable({
  providedIn: 'root'
})
export class ApiService {

  // BehaviorSubject ! Interessante ! Permette notifica automatica con observable...
  private _boats = new BehaviorSubject(null);  // ATTENZIONE, inizializzo a null, tutti gli utenti del BehaviourSubject ricevono questo dato la prima volta
  readonly boatsObservable = this._boats.asObservable(); // Da utilizzare per notifiche automatiche cambiamento
  boats : any[] = [];         // Dati imbarcazione eventualmente parzializzati in caso playback
  boatsCache : any[] = [];    // Copia dati interna (cache) 

  id_event : number = 0;
  event : Event = {
    name: "",
    customer: "",
    description: "",
    location:"",
    website: "",
    begin: "",
    end:"",
    tracking_begin:"",
    tracking_end:"",
    trackinginterval: 0,
    centerlatitude:"",
    centerlongitude:"",
    startzoom: "",
    markers : [] 
  };

  boatClasses: BoatClass[] = [];
  boatClassesAllVisible: boolean;

  boatIcons = []; // Array di icone/palette per imbarcazioni
  buoyIcon:any;   // Icona speciale usata da boe/marker dotati di tracking, fissa colore giallo
  boatsLayer: BoatLayer[] = [];

  boatsLeaderBoards : BoatLeaderBoard[] = [];
  private _boatsLeaderBoards = new BehaviorSubject(null);  // ATTENZIONE, inizializzo a null, tutti gli utenti del BehaviourSubject ricevono questo dato la prima volta
  readonly boatsLeaderBoardsObservable = this._boatsLeaderBoards.asObservable(); // Da utilizzare per notifiche automatiche cambiamento
  boatLeaderBoardFilterValue: string = "";
  boatLeaderBoardOrderType : number = 1;  // 0=Nessuno, 1=Name, 2... (vedi codice !!)
  boatLeaderBoardOrderTypeText : string = "Order by name";
  boatLeaderBoardTrackVisibilityBuffer: boolean;

  private _messageService = new Subject <any>();
  messageServiceObservable = this._messageService.asObservable();

  reloadInterval: number = 0; 
  reloadIntervalCounter: number = 0; 
  lastUpdateEpoch = 0;
  lastUpdateDateTimeString:string = "";

  trackingBeginEpoch: number = 0;
  trackingEndEpoch: number = 0;
  trackingInterval: number = 0;

  mapMouseLat:number = 0;
  mapMouseLon:number = 0;
  mapReadyStatus:number = -1;  // -1=Da inizializzare, 0=In attesa, 1=WindyOK, 3=Barche disegnate almeno una volta !  
  eventReadyStatus:number = 0; // 0=Evento non letto, 1=evento letto e disponibile
  mapCenterZoomString:string="?";

  // Playback
  playbackCounter = 0;
  playbackEpoch = 0;                  // 1528884000; // 0 
  playbackSpeed:number = 5;	
  playbackDateTime = "";
  playbackActive = false;             // Il playback potrebbe essere abilitato ma sospeso
  playbackEnabled = false;            
  playbackEnabledAutoDetect = true;   // Entra in modo playback automaticamente se data odierna superiore a fine regata
  playbackBeginEpoch:number = 0;      // ATTENZIONE, tutti gli epoch sono al secondo come PHP, non ms
  playbackEndEpoch:number = 0;
  playbackEpochInterval:number = 300; // 1800;        // 1800 = 30 minuti
  playbackTimerInterval:number = 1;   // Intervallo ridisegno playback in secondi, scelgo 2 per compromesso prestazioni
  playbackTimerIntervalCounter:number = 0;    

  update() {
    this.reloadIntervalCounter=this.reloadInterval;
  }

  constructor(private http: HttpClient) {

    // Lettura evento passato a parametro
    var urlParams = new URLSearchParams(location.search);
    if (urlParams.has('id')==true)
    {
      this.id_event = parseInt(urlParams.get('id'));
      // console.log(this.id_event);   
    }
    else
    {
      // 30/05/2023 Provo a gestire eccezione senza evento con redirect
      // alla pagina generale eventi live...
      // alert("Evento non specificato!");
      // ATTENZIONE DA VERIFICARE !!!
      window.location.href = "..//live-events.html";
      return;
    }  

    // Creo array icone disponibili da assegnare alle imbarcazioni
    this.createBoatIcons();

    // La prima volta leggo dati evento
    this.http.post("api/load_event.php", {
      "id_event" :   this.id_event
    }).subscribe((data: any) => {

      this.event = data;
      this.eventReadyStatus = 1;  // Semaforo per avvisare dati evento disponibili....

      this.trackingBeginEpoch = moment(this.event.tracking_begin).unix();
      this.trackingEndEpoch = moment(this.event.tracking_end).unix();
      this.trackingInterval = this.event.trackinginterval;

      console.log("api read trackingBeginEpoch="+ this.event.tracking_begin + "/ " + this.trackingBeginEpoch);
      console.log("api read trackingEndEpoch=" + this.event.tracking_end + "/ "  +this.trackingEndEpoch);
      console.log("api read trackingInterval=" + this.event.trackinginterval);
      console.log(this.event);

      // La prima volta chiedo comunque i dati completi impostando epoch=0
      this.http.post("api/load_boats.php", {
        "id_event" :   this.id_event,
        "trackingBeginEpoch" : this.trackingBeginEpoch,
        "trackingEndEpoch" :  this.trackingEndEpoch,
        "epoch": "0", // 0 => update completo !!
      }).subscribe((data: any[]) => {
        
        // Decido di implementare la simulazione lato api e non client app
        // In questo modo tutti i subscriber possono essere sincronizzati, incluso leaderboard
        this.processBoatsDataAndBroadcast(data);
      });

      // Avvio timer per successivi (eventuali) aggiornamento dati solo se reloadInterval>0
      timer(1000,1000).subscribe(()=>{

        // Controllo ed eventualmente attivo playback
        if ((this.playbackEnabled==false)&&(this.playbackEnabledAutoDetect)&&(moment().unix() > this.trackingEndEpoch))
        // if (false)
        {
          this.playbackEnabled = true;  // Abilito playback se data attuale > data fine evento
          this.playbackActive = true;   // Stato attivo, potrà essere fermato dal controllo
          this.playbackBeginEpoch = this.trackingBeginEpoch;
          this.playbackEndEpoch = this.trackingEndEpoch;
          this.playbackEpoch =  this.trackingBeginEpoch;  
          this.playbackDateTime = moment.unix(this.playbackEpoch).format("DD/MM/YY HH:mm");
        }  

        // Se playback 
        if (this.playbackEnabled == true)
        {
          // Il playback deve chiamare manualmente il metodo di redraw della mappa
          // ATTENZIONE, forzo il ridisegno anche se la mappa non ancora completa
          if ((this.playbackTimerIntervalCounter >= this.playbackTimerInterval) || (this.mapReadyStatus<2))
          {
            this.playbackTimerIntervalCounter = 0;                     
            // this.playbackEpoch = this.playbackEpoch + this.playbackEpochInterval;
            // La velocità avanzamento playback dipende dal parametro playbackSpeed
            this.playbackEpoch = this.playbackEpoch + this.playbackEpochInterval * this.playbackSpeed;
            if (this.playbackEpoch > this.trackingEndEpoch)      
              this.playbackEpoch =  this.trackingBeginEpoch; 
            this.playbackDateTime = moment.unix(this.playbackEpoch).format("DD/MM/YY HH:mm");
            
            this.processBoatsDataAndBroadcast(this.boatsCache);   // Invio i dati completi per elaborazione
          }
          else
          {
            if (this.playbackActive == true)
              this.playbackTimerIntervalCounter++;
          }  
        }
        else {
          // Devo richiedere i dati al database ma solo se l'intervallo aggiornamento è scaduto
          // Lo richiedo comunque se la mappa non è ancora stata ridisegnata, serve per evitare blocco
          if ((this.reloadInterval > 0) || (this.mapReadyStatus<2)) {
              this.reloadIntervalCounter++;
              // if (this.reloadIntervalCounter > this.reloadInterval) 
              // console.log("api.service.this.mapReadyStatus="+this.mapReadyStatus);
              // ATTENZIONE CERCO DI FORZARE RELOAD SE NON HO ANCORA DISEGNATO
              if ((this.reloadIntervalCounter > this.reloadInterval)||(this.mapReadyStatus<2))
              {
                console.log("this.trackingBeginEpoch=" + this.trackingBeginEpoch + " this.trackingEndEpoch=" + this.trackingEndEpoch);
                this.reloadIntervalCounter = 0;

                // 26/05/2023 ATTENZIONE Rilettura dati evento ad ogni aggiornamento
                // Sono costretto a farlo perchè l'aggiornamento posizione marker che puo avvenire con
                // la nuova gestione delle imbarcazioni boe/marker fa cambioare i dati evento
                this.http.post("api/load_event.php", {
                  "id_event" :   this.id_event
                }).subscribe((data: any) => {
            
                  this.event = data;
                  // this.eventReadyStatus = 1;  // Semaforo per avvisare dati evento disponibili....
            
                  this.trackingBeginEpoch = moment(this.event.tracking_begin).unix();
                  this.trackingEndEpoch = moment(this.event.tracking_end).unix();
                  this.trackingInterval = this.event.trackinginterval;
            
                  // console.log("api reload trackingBeginEpoch="+ this.event.tracking_begin + "/ " + this.trackingBeginEpoch);
                  // console.log("api reload trackingEndEpoch=" + this.event.tracking_end + "/ "  +this.trackingEndEpoch);
                  // console.log("api reload trackingInterval=" + this.event.trackinginterval);
                  console.log(this.event);

                  // Chiedo "update" dati imbarcazioni, lo faccio impostando epoch=1 
                  this.http.post("api/load_boats.php", {
                    "id_event" :   this.id_event,
                    "trackingBeginEpoch" : this.trackingBeginEpoch,
                    "trackingEndEpoch" :   this.trackingEndEpoch,
                    "epoch" : "1" // 1 => update ultime 10 posizioni !!
                  }).subscribe((data: any[]) => {
                    var boatsIdx = -1;
                    var boatsLastEpochIdx = -1;
                    // Ho ricevuto un update parziale contenente solo le ultime posizioni
                    // Devo ricopiare le posizioni precedenti dalla cache
                    for (let i=0;i<data.length;i++) {              
                      var currentIdx = data[i].track_epoch.length;
                      // Ricerco indice nell'array cache
                      boatsIdx = -1;
                      boatsLastEpochIdx = -1; // lastCacheIdx = -1;
                      for (let j=0;j<this.boatsCache.length;j++)
                      {
                        if (this.boatsCache[j].dev_sn == data[i].dev_sn)
                        {
                          boatsIdx = j;
                          boatsLastEpochIdx = this.boatsCache[j].track_epoch.length -1;
                          
                          // ATTENZIONE ATTENZIONE !!!! Devo ricopiare questo dato perchè esternamente protrebbe essere stato
                          data[i].visible = this.boatsCache[j].visible;  // Preservo visible, non lo devo rileggere !!
                          data[i].fullTrackVisible = this.boatsCache[j].fullTrackVisible;  // Preservo visibilità traccia completa, non lo devo rileggere !!
                          // console.log("cache found - dev_sn= " + this.boats[j].dev_sn + " / boatsIdx = " + boatsIdx + " / lastCacheIdx = " + boatsLastEpochIdx);
                          break;
                        }
                      }
                      // L'imbarcazione esiste nella cache, devo accodare le nuove posizioni in quelle contenute nelle cache
                      // Per comodità prima copio i nuovi dati nella cache e quindi ricopio la cache nei dati ricevuti
                      if (boatsIdx > -1) {
                        for (let j=0;j<data[i].track_epoch.length;j++) {
                          if (data[i].track_epoch[j] > this.boatsCache[boatsIdx].track_epoch[boatsLastEpochIdx]) {
                            this.boatsCache[boatsIdx].track_latlon.push(data[i].track_latlon[j]);
                            this.boatsCache[boatsIdx].track_epoch.push(data[i].track_epoch[j]);
                          }
                          
                        }
                        // Ricopio da cache dopo il suo aggiornamento
                        data[i].track_epoch = this.boatsCache[boatsIdx].track_epoch;
                        data[i].track_latlon = this.boatsCache[boatsIdx].track_latlon;
                      }
                      else {
                        // Se la cache non contiene elemento allora il dato ricevuto è già completo, non serve leggere nulla dalla cache
                        // console.log("cache empty - boatsIdx =" + boatsIdx);
                      }
                    // ATTENZIONE, TODO 
                    // Resta un altro problema, se una imbarcazione viene rimossa dall'evento i dati cache potrebbero
                    // contenete imbarcazioni non valide che non sarebbero rimosse.. 
                    // Bisognerebbe anche rimuovere
                    }  
                    // Ricopio i dati ricevuti aggiornati nella cache in modo da tenerla aggiornata
                    this.processBoatsDataAndBroadcast(data); // Invio i dati aggiornati
                  }); // subscribe lettura imbarcazioni
                }); // subscribe lettura evento
              };
          } // reloadInterval
        }
      }); // Timer   
    });
  } 
  //---------------------------------------------------------------------------
  processBoatsDataAndBroadcast(data:any) {

    // Aggiorno tutte le strutture dati che dipendono dai dati imbarcazione
    // Questa funzione deve ricevere sempre i dati imbarcazione completi, cioè contenete tutte le posizioni.
    // Questa funzione manitene aggiornate due strutture dati :
    // this.api.boats : da utilizzare esternamente, contiene i dati completi eventualmente tagliati da playback
    // this.api.boatsCache : copia cache interna contenente sempre tutti i dati completi anche in caso di playback
    
    // Copio in cache i dati inviati
    this.boatsCache = JSON.parse(JSON.stringify(data)); 

    // ATTENZIONE solo per debug, aggiungo classi alla lista
    /*
    if (this.boatClasses.length ==0) {
      this.boatClasses.push({"name":"CLASS 1","visible": false });  
      this.boatClasses.push({"name":"CLASS 2","visible": false });  
      this.boatClasses.push({"name":"CLASS 3","visible": false });  
    }
    */

    // Voglio mantenere aggiornato elenco delle classi presenti
    // ATTENZIONE Aggiungo le eventuali nuove classi senza sovrascrivere il campo visible che viene usato dai componenti !
    let iconColor = 0;

    // Per ogni imbarcazione verifico la classe ed eventualmente aggiungo a boatClasses se non presente.
    // Per ogni imbarcazione aggiorno colore e codice html icona
    // Per ogni imbarcazione traduco in testo lo stato di navigazione
    // Per ogni imbarcazione calcolo velocità di avvicinamento VMC su ultimi 5 punti
    for (let i=0;i<this.boatsCache.length;i++) {
      let classFound = false;
      for (let j=0;j<this.boatClasses.length;j++) {
        if (this.boatClasses[j].name == this.boatsCache[i].class) {
          classFound = true;
          break;
        }  
      }
      // Aggiungo eventuale nuova classe ed imposto visibile di default !!
      if (classFound == false) {
        this.boatClasses.push({"name":this.boatsCache[i].class,
                                "visible": true });  
      }
      // Aggiorno la barca assegnando un indice all'icona che sarà utilizzata
      // Per comodità assegno anche un colore
      
      if (this.boatsCache[i].class == "MARKER")
      {
        this.boatsCache[i].iconColor = this.buoyIcon.color;
        this.boatsCache[i].iconColorInverted = this.buoyIcon.colorInverted;
        this.boatsCache[i].iconHtml = this.buoyIcon.html;
      }
      else
      {
        this.boatsCache[i].iconColor = this.boatIcons[iconColor].color;
        this.boatsCache[i].iconColorInverted = this.boatIcons[iconColor].colorInverted;
        this.boatsCache[i].iconHtml = this.boatIcons[iconColor].html;
        iconColor++;
        if (iconColor >= this.boatIcons.length)
          iconColor = 0
      }
          

      // Scrivo nav_status come stringa
      switch (this.boatsCache[i].nav_status) 
      {
        case 0 : this.boatsCache[i].nav_status_text = "---"; break;
        case 10 : this.boatsCache[i].nav_status_text = "Do not compete (DNC)";  break;
        case 20 : this.boatsCache[i].nav_status_text = "Do not finish (DNF)"; break;
        case 50 : this.boatsCache[i].nav_status_text = "Racing"; ;break;
        case 100 : this.boatsCache[i].nav_status_text = "Arrived";; break;
      } 
      
      // La proprietà fullTrackVisible non è presente nel database, la aggiungo defualt se assente
      if (this.boatsCache[i].fullTrackVisible == undefined)
        this.boatsCache[i].fullTrackVisible = false;

    }

    // Aggiorno variabile che indica se tutte le classi sono visibili
    let allClassVisible=true;
    for (let i=0;i<this.boatClasses.length;i++) {
      if (this.boatClasses[i].visible == false)
        allClassVisible = false;
    }
    this.boatClassesAllVisible = allClassVisible;
 

    // Ordinamento classi
    // ATTENZIONE NON CANCELLARE....
    // this.boatClasses.sort((a,b)=>{return (a.name.localeCompare(b.name))});    
    // Tentativo ordinamento, la classe speciale "MARKER" viene messa sempre
    // per ultima indipendentemente.
    this.boatClasses.sort((a,b)=>{
      if (a.name=="MARKER") 
        return 1
      else if (b.name=="MARKER") 
        return -1
      else
        return (a.name.localeCompare(b.name))
      });    

    // Gestione playback
    // Nota che elaboro data e non boats che deve mantenerli sempre tutti !
    if (this.playbackEnabled == true) {

      // Il playback deve "tagliare" le posizioni successive alla data di playback.
      // Se taglio l'array boatsCache[] o una sua copia non "profonda" perdo i dati per sempre, devo fare una copia "profonda" e lavorare su quella.
      // Ricopio dati completi da cache in dati da elaborare per playback.
      this.boats = JSON.parse(JSON.stringify(this.boatsCache)); 

      for (let i=0;i<this.boats.length;i++){
        var lastTrackId = -1;
        for (let j=0;j<this.boats[i].track_epoch.length;j++){ 
          // Se epoch elemento corrente maggiore epoch playback allora mi devo fermare al precedente
          if (this.boats[i].track_epoch[j]>this.playbackEpoch)
          {
            lastTrackId = j-1;
            break;  // esco dal loop, tutti gli eventuali  punti successivi sono con data successiva
          }
        }
        // TODO ATTENZIONE !!! Tolgo le posizioni che sono successive a lastTrackId
        // L'array this.boatsCache non viene modificato
        this.boats[i].track_latlon = this.boatsCache[i].track_latlon.slice(0,lastTrackId+1);
        this.boats[i].track_epoch = this.boatsCache[i].track_epoch.slice(0,lastTrackId+1);
      }  

      // Calcolo data ultimo messaggio per ogni imbarcazione
      let lastUpdateEpoch = 0;
      for (let i=0;i<this.boats.length;i++) {
        this.boats[i].last_msg_epoch = this.boats[i].track_epoch[this.boats[i].track_epoch.length-1];
        this.boats[i].last_msg_datetime = moment.unix(this.boats[i].last_msg_epoch).format("DD/MM/YY HH:mm");
        if (this.boats[i].last_msg_epoch > lastUpdateEpoch)
          lastUpdateEpoch = this.boats[i].last_msg_epoch;
      }
      if (lastUpdateEpoch > 0) {
        this.lastUpdateEpoch = lastUpdateEpoch;
        this.lastUpdateDateTimeString = moment.unix(this.lastUpdateEpoch).format("DD/MM/YY HH:mm");  
      } else {
        this.lastUpdateEpoch = 0;
        this.lastUpdateDateTimeString = "?";
      }  

    } // this.playbackEnabled == true 
    else
    {
      // In caso di funzionamento normale (non playback) invio tutti i dati completi

      // Funzionamento normale, non playback, invio tutti i dati ricevuti
      let lastUpdateEpoch = 0;
      for (let i=0;i<this.boatsCache.length;i++) {
        
        if (this.boatsCache[i].track_epoch.length>0) {
          this.boatsCache[i].last_msg_epoch = this.boatsCache[i].track_epoch[this.boatsCache[i].track_epoch.length-1];
          this.boatsCache[i].last_msg_datetime = moment.unix(this.boatsCache[i].last_msg_epoch).format("DD/MM/YY HH:mm");
        }
        else {
          this.boatsCache[i].last_msg_epoch = 0;
          this.boatsCache[i].last_msg_datetime = "---";
        }

        if (this.boatsCache[i].last_msg_epoch > lastUpdateEpoch)
          lastUpdateEpoch = this.boatsCache[i].last_msg_epoch;
      }
      if (lastUpdateEpoch > 0)
      {
        this.lastUpdateEpoch = lastUpdateEpoch;
        this.lastUpdateDateTimeString = moment.unix(this.lastUpdateEpoch).format("DD/MM/YY HH:mm");  
      } else {
        this.lastUpdateDateTimeString = "";
        this.lastUpdateDateTimeString = "?";
      }
      this.boats = JSON.parse(JSON.stringify(this.boatsCache)); 
    } 

    // Calcolo della velocità avvicinamento
    var distanceElapsed = 0;
    var timeElapsed = 0;
    for (let i=0;i<this.boats.length;i++) {
      
      let trackLength = this.boats[i].track_latlon.length;
      // let nPoints = Math.min(trackLength,9);  // ATTENZIONE!!! Non devo leggere più punti di quanti sono disponibili 
      let nPoints = Math.min(trackLength,5);  // ATTENZIONE!!! Non devo leggere più punti di quanti sono disponibili 

      if (nPoints >=2) {
        var nav_next_wp_lat = this.boats[i].nav_next_wp_lat;
        var nav_next_wp_lon = this.boats[i].nav_next_wp_lon;
        var FirstLat = this.boats[i].track_latlon[trackLength-nPoints][0];
        var FirstLon = this.boats[i].track_latlon[trackLength-nPoints][1];
        var FirstEpoch = this.boats[i].track_epoch[trackLength-nPoints];
        var LastLat = this.boats[i].track_latlon[trackLength-1][0];
        var LastLon = this.boats[i].track_latlon[trackLength-1][1];
        var LastEpoch = this.boats[i].track_epoch[trackLength-1];
        
        var FirstDistance = this.distanceHaversine(FirstLat,FirstLon,nav_next_wp_lat,nav_next_wp_lon,'N');
        var LastDistance = this.distanceHaversine(LastLat,LastLon,nav_next_wp_lat,nav_next_wp_lon,'N');

        var distance = FirstDistance - LastDistance;
        var speedVMC = (distance / (LastEpoch - FirstEpoch))*3600; // NM/h
        
        
        // ATTENZIONE, cerco di cambiare calcolo velocità con media punti
        // var speedCOG = (this.distanceHaversine(FirstLat,FirstLon,LastLat,LastLon,'N')/(LastEpoch - FirstEpoch))*3600; // NM/h
        
        distance = 0;
        for (let n=0;n<nPoints-1;n++) {
          FirstLat = this.boats[i].track_latlon[trackLength-nPoints+n][0];
          FirstLon = this.boats[i].track_latlon[trackLength-nPoints+n][1];  
          LastLat = this.boats[i].track_latlon[trackLength-nPoints+n+1][0];
          LastLon = this.boats[i].track_latlon[trackLength-nPoints+n+1][1];  
          distance = distance + this.distanceHaversine(FirstLat,FirstLon,LastLat,LastLon,'N');
        }

        var speedCOG = (distance)/(LastEpoch - FirstEpoch)*3600; // NM/h


        this.boats[i].sog = speedCOG;
        this.boats[i].vmg = speedVMC;
      }
      else {
        this.boats[i].sog = 0.0;
        this.boats[i].vmg = 0.0;
      }  

      // ATTENZIONE 12/06/2019 ORE 21, dopo il disastro passaggio Giraglia decido di NON usare speedVMC
      // if (speedVMC > 0) {
      //   this.boats[i].nav_ttg_tot = (this.boats[i].nav_dtg_tot / speedVMC) * 3600.0;  // Tempo per arricare in secondi 
      //   // this.boats[i].nav_eta_epoch = moment().unix() + this.boats[i].nav_ttg_tot;  // Data di arrivo in secondi (epoch)
      //   this.boats[i].nav_eta_epoch = this.boats[i].last_msg_epoch + this.boats[i].nav_ttg_tot;  // Data di arrivo in secondi (epoch)
      //   let totalSeconds = this.boats[i].nav_ttg_tot;
      //   let hours = Math.floor(totalSeconds / 3600);
      //   totalSeconds %= 3600;
      //   let minutes = Math.floor(totalSeconds / 60);
      //   this.boats[i].nav_ttg_tot_text = hours.toString() + "h " + minutes.toString() + "m"
      //   this.boats[i].nav_eta_text = moment.unix(this.boats[i].nav_eta_epoch).format("DD/MM/YY HH:mm");
  
      // } 
      // else {
      //   this.boats[i].nav_ttg_tot = this.trackingEndEpoch - this.boats[i].last_msg_epoch; // ment().unix();  
      //   this.boats[i].nav_eta_epoch = this.trackingEndEpoch;  // Imposto data arrivo = fine regata/tracking 
      //   // this.boats[i].nav_eta_text = "---";     
      //   // this.boats[i].nav_ttg_tot_text = "---"

      //   // ATTENZIONE SOLO PER DEBUG
      //   // let totalSeconds = this.boats[i].nav_ttg_tot;
      //   // let hours = Math.floor(totalSeconds / 3600);
      //   // totalSeconds %= 3600;
      //   // let minutes = Math.floor(totalSeconds / 60);
      //   // this.boats[i].nav_ttg_tot_text = hours.toString() + "h " + minutes.toString() + "m"
      //   // this.boats[i].nav_eta_text = moment.unix(this.boats[i].nav_eta_epoch).format("DD/MM/YY HH:mm");

      // }  

      if (speedCOG > 0) {
        this.boats[i].nav_ttg_tot = (this.boats[i].nav_dtg_tot / speedCOG) * 3600.0;  // Tempo per arricare in secondi 
        // this.boats[i].nav_eta_epoch = moment().unix() + this.boats[i].nav_ttg_tot;  // Data di arrivo in secondi (epoch)
        this.boats[i].nav_eta_epoch = this.boats[i].last_msg_epoch + this.boats[i].nav_ttg_tot;  // Data di arrivo in secondi (epoch)
        let totalSeconds = this.boats[i].nav_ttg_tot;
        let hours = Math.floor(totalSeconds / 3600);
        totalSeconds %= 3600;
        let minutes = Math.floor(totalSeconds / 60);
        this.boats[i].nav_ttg_tot_text = hours.toString() + "h " + minutes.toString() + "m"
        this.boats[i].nav_eta_text = moment.unix(this.boats[i].nav_eta_epoch).format("DD/MM/YY HH:mm");
  
      } 
      else {
        this.boats[i].nav_ttg_tot = this.trackingEndEpoch - this.boats[i].last_msg_epoch; // ment().unix();  
        this.boats[i].nav_eta_epoch = this.trackingEndEpoch;  // Imposto data arrivo = fine regata/tracking 
        // this.boats[i].nav_eta_text = "---";     
        // this.boats[i].nav_ttg_tot_text = "---"

        // ATTENZIONE SOLO PER DEBUG
        // let totalSeconds = this.boats[i].nav_ttg_tot;
        // let hours = Math.floor(totalSeconds / 3600);
        // totalSeconds %= 3600;
        // let minutes = Math.floor(totalSeconds / 60);
        // this.boats[i].nav_ttg_tot_text = hours.toString() + "h " + minutes.toString() + "m"
        // this.boats[i].nav_eta_text = moment.unix(this.boats[i].nav_eta_epoch).format("DD/MM/YY HH:mm");

      }  




      if (this.boats[i].nav_status == 100)
        this.boats[i].nav_toa_text =  moment.unix(this.boats[i].nav_toa_epoch).format("DD/MM/YY HH:mm");
      else
        this.boats[i].nav_toa_text  = "";

      // TODO ATTENZIONE non riesco a convertire in ore e secondi ma in ore con decimale
      // this.boats[i].nav_ttg_tot_text = moment.duration(this.boats[i].nav_ttg_tot, 'seconds').asHours();
      // this.boats[i].nav_ttg_tot_text = moment.duration(this.boats[i].nav_ttg_tot, 'seconds').hours() + "h " +moment.duration(this.boats[i].nav_ttg_tot, 'seconds').minutes() +"m";
      // this.boats[i].nav_ttg_tot_text = moment.duration(this.boats[i].nav_ttg_tot, 'seconds').hours();
      // this.boats[i].nav_ttg_tot_text = moment.duration(this.boats[i].nav_ttg_tot, 'seconds').humanize();
      // this.boats[i].nav_ttg_tot_text = moment.utc(moment.duration(this.boats[i].nav_ttg_tot,"seconds").asMilliseconds()).format("HH:mm:ss");
      // this.boats[i].nav_eta_text = moment.unix(this.boats[i].nav_eta_epoch).format("DD/MM/YY HH:mm");
      // console.log("speedVMC = " + speedVMC + " / SpeedCOG = " + speedCOG);

    }  

    // Notifico cambiamenti dati barca a tutti i subscribers
    this._boats.next(this.boats);

    // Chiamo la funzione per aggiornamento LeaderBoard , devo farlo perchè i dati potrebbero essere cambiati
    // ATTENZIONE La funzione updateBoatLeaderBoards() inoltra gli observable alla fine elaborazione
    this.updateBoatLeaderBoards(this.boats);

  }
  //---------------------------------------------------------------------------
  createBoatIcons() {
    
    // Creo un array contenente il codice HTML per le icone imbarcazione
    // La dimensione icona SVG non è importante, viene scalata !!
    // 16 x 48
    // var iconHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 48"><title>$title</title><path d="M.16,48s-.38-10.84,0-16.24A112.05,112.05,0,0,1,2.61,14.58q1.11-4.59,2.67-9c.71-2,1.44-3.79,2-5A.82.82,0,0,1,8.34.08a.85.85,0,0,1,.42.44c.53,1.27,1.28,3.1,2,5q1.56,4.45,2.67,9a112.12,112.12,0,0,1,2.43,17.18c.4,5.4,0,16.24,0,16.24Z" transform="translate(0 0)" style="fill:$color"/></svg>`;
    var iconHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 48"><path d="M.16,48s-.38-10.84,0-16.24A112.05,112.05,0,0,1,2.61,14.58q1.11-4.59,2.67-9c.71-2,1.44-3.79,2-5A.82.82,0,0,1,8.34.08a.85.85,0,0,1,.42.44c.53,1.27,1.28,3.1,2,5q1.56,4.45,2.67,9a112.12,112.12,0,0,1,2.43,17.18c.4,5.4,0,16.24,0,16.24Z" transform="translate(0 0)" style="fill:$color"/></svg>`;
    var boatIconsCount =  0;
    // NOTA La proprietà "colorInverted" serve per l'header del pannello imbarcazioni ad indicare il colore ottimale per scrivere
    // con testo sopra colore primario, per adesso è servito solo per acqua che richiede nero al posto di bianco..
    this.boatIcons.push({"color":"blue","colorInverted":"white","html":iconHTML.replace("$color","blue")}); boatIconsCount++;
    this.boatIcons.push({"color":"red","colorInverted":"white","html":iconHTML.replace("$color","red")});boatIconsCount++;
    this.boatIcons.push({"color":"green","colorInverted":"white","html":iconHTML.replace("$color","green")});boatIconsCount++;
    this.boatIcons.push({"color":"fuchsia","colorInverted":"white","html":iconHTML.replace("$color","fuchsia")});boatIconsCount++;
    this.boatIcons.push({"color":"gray","colorInverted":"white","html":iconHTML.replace("$color","gray")});boatIconsCount++;
    this.boatIcons.push({"color":"orange","colorInverted":"white","html":iconHTML.replace("$color","orange")});boatIconsCount++;
    this.boatIcons.push({"color":"brown","colorInverted":"white","html":iconHTML.replace("$color","brown")});boatIconsCount++;
    this.boatIcons.push({"color":"teal","colorInverted":"white","html":iconHTML.replace("$color","teal")});boatIconsCount++;
    this.boatIcons.push({"color":"aqua","colorInverted":"black","html":iconHTML.replace("$color","aqua")});boatIconsCount++;
    this.boatIcons.push({"color":"maroon","colorInverted":"white","html":iconHTML.replace("$color","maroon")});boatIconsCount++;
    this.boatIcons.push({"color":"purple","colorInverted":"white","html":iconHTML.replace("$color","purple")});boatIconsCount++;
    this.boatIcons.push({"color":"black","colorInverted":"white","html":iconHTML.replace("$color","black")});boatIconsCount++;

    // Tentativo gestione icona separata per boe legate al tracking la scrivo qui perchè e comunque una "barca"
    // Nota che non devo cambiare il colore, resta giallo fisso
    var buoyIconHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><circle cx="24" cy="24" r="24" stroke="black" stroke-width="1" fill="yellow" /></svg>`
    this.buoyIcon = {"color":"yellow","colorInverted":"black","html":buoyIconHTML};

  }
  //---------------------------------------------------------------------------
  playbackPlay(){
    
    this.playbackActive = true;
  }
  //---------------------------------------------------------------------------
  playbackPause(){
    this.playbackActive = false;
  }
  //---------------------------------------------------------------------------
  playbackRestart(){
    this.playbackEpoch = this.trackingBeginEpoch;  

  }
  //---------------------------------------------------------------------------
  toggleclassVisibility(classId:number){
    
    
    this.boatClasses[classId].visible = !this.boatClasses[classId].visible;
    let allVisible = true;
    for (let i=0;i<this.boatClasses.length;i++) {
      if (this.boatClasses[i].visible == false)
        allVisible = false;
    }
    this.boatClassesAllVisible = allVisible;

    // Adesso imposto la visibilità per le singole imbarcazioni
    for (let i=0;i<this.boats.length;i++) {
      for (let j=0;j<this.boatClasses.length;j++) {
        if (this.boats[i].class == this.boatClasses[j].name) {
          this.boats[i].visible = this.boatClasses[j].visible;
          this.boatsCache[i].visible = this.boatClasses[j].visible;
          break;
        }  
      }
    }

    // Chiamo funzione che riaggiorna lista LeaderBoard e notifica cambiamento
    this.updateBoatLeaderBoards(this.boats);
    // console.log("toggleclassVisibility for class =" + this.boatClasses[classId].name);  
  }
  //---------------------------------------------------------------------------
  toggleclassVisibilityAll(){
    
    // Prima verifico se tutte le classi sono visibili
    this.boatClassesAllVisible = ! this.boatClassesAllVisible;
    for (let i=0;i<this.boatClasses.length;i++) {
      this.boatClasses[i].visible = this.boatClassesAllVisible;
    }

    // Adesso imposto la visibilità per le singole imbarcazioni
    for (let i=0;i<this.boats.length;i++) {
      for (let j=0;j<this.boatClasses.length;j++) {
        if (this.boats[i].class == this.boatClasses[j].name) {
          this.boats[i].visible = this.boatClasses[j].visible;
          this.boatsCache[i].visible = this.boatClasses[j].visible;
          break;
        }  
      }
    }

    // Chiamo funzione che riaggiorna lista LeaderBoard e notifica cambiamento
    this.updateBoatLeaderBoards(this.boats);
    // console.log("setclassVisibilityAll");  
  }
  //---------------------------------------------------------------------------
  setBoatFullTrackVisibility(boatId:number,status:boolean){
    
    this.boats[boatId].fullTrackVisible = status;
    this.boatsCache[boatId].fullTrackVisible = status;
  }
  //---------------------------------------------------------------------------
  leaderBoardBoatClick(boatId:number,eventSource:string) {
    // 
    // In caso di chiamata a questa funzione devo inoltrare a tutti i subscriber
    // un messaggio per informarli della avvenuta selezione della barca boatId
    // La sorgente evento è "boats.component", il destinatario è "app.components"
    // utilizzo il servizio api come intermediario e repository dati aggiornati
    
    // Se la barca non ha marker allora non faccio nulla per evitare errori
    // if (this.boatsLayer[boatId].marker == 0)
    //   return;

    
    // TODO ATTENZIONE DA PROVARE
    // Devo gestire gli eventi di click sulla leaderboard ed aggiornare lo stato
    // degli array imbarcazioni in modo che tutti i subscriber abbiamo i dati aggiornati
    // Non posso gestirli a valle, i subscriber degli eventi devono
    for (let i=0;i<this.boatsLeaderBoards.length;i++) {
      if (this.boatsLeaderBoards[i].boatId == boatId) {
        if (eventSource=="click") {
          this.boatsLeaderBoards[i].fullTrackVisible = !this.boatLeaderBoardTrackVisibilityBuffer
          this.boatLeaderBoardTrackVisibilityBuffer=this.boatsLeaderBoards[i].fullTrackVisible;
        } else if  (eventSource=="mouseenter") {
          this.boatLeaderBoardTrackVisibilityBuffer=this.boatsLeaderBoards[i].fullTrackVisible;
          this.boatsLeaderBoards[i].fullTrackVisible=true;       
        } else if  (eventSource=="mouseleave") {
          this.boatsLeaderBoards[i].fullTrackVisible=this.boatLeaderBoardTrackVisibilityBuffer;       
        }
        // Aggiorna gli array boats/boatsCache che mantengono il dato se viene aggiornata
        // la leadeboard alla lettura nuovi dati...
        this.setBoatFullTrackVisibility(boatId,this.boatsLeaderBoards[i].fullTrackVisible);  
      }
    }
    // console.log("leaderBoardBoatClick::eventSource="+eventSource);
    // this._messageService.next(boatId);  
    this._messageService.next({"id":boatId,"event":eventSource});  
  }
  //---------------------------------------------------------------------------
  updateBoatLeaderBoards (data:any[]) {
  
    // Aggiorna l'array boatsLeaderBoards[], derivato da quello boats[] applicando filtro e classifica
    // Ricopio le barche visibili e che contengono la stringa dell'eventuale filtro "boatLeaderBoardFilterValue"
    // Sulla lista imbarcazione applico l'ordinamento indicato in "boatLeaderBoardOrderType"
    // Lo ricreo tutte le volte, utilizzo i dati imbarcazioni senza cache, in modo che siano automaticamente tagliati in caso playback
    this.boatsLeaderBoards = [];
    for (let i=0;i<data.length;i++) {
      // Aggiungo elemento solo se imbarcazione visibile e se contiene il testo uppercase del filtro.
      let boatNameFound = data[i].name.toUpperCase().includes(this.boatLeaderBoardFilterValue.toUpperCase());
      if ((data[i].visible == true) && ((this.boatLeaderBoardFilterValue=="")||(boatNameFound))) {
          this.boatsLeaderBoards.push({
            boatId: i,
            dev_sn: data[i].dev_sn,
            dev_name: data[i].dev_name,
            name: data[i].name,
            class: data[i].class,
            sailn: data[i].sailn,
            iconColor:  data[i].iconColor,
            visible: data[i].visible,
            fullTrackVisible: data[i].fullTrackVisible, 
            nav_status: data[i].nav_status,
            nav_status_text: data[i].nav_status_text,
            nav_dtg_tot: data[i].nav_dtg_tot,
            last_msg_datetime: data[i].last_msg_datetime,
            last_msg_epoch: data[i].last_msg_epoch,
            distanceSailed: 0.0,
            startDateTime: moment.unix(this.trackingBeginEpoch).format("DD/MM/YY HH:mm"),
            nav_ttg_tot: data[i].nav_ttg_tot,
            nav_ttg_tot_text: data[i].nav_ttg_tot_text,
            nav_eta_epoch: data[i].nav_eta_epoch,
            nav_eta_text: data[i].nav_eta_text,
            nav_toa_epoch: data[i].nav_toa_epoch,
            nav_toa_text: data[i].nav_toa_text,
            cog: data[i].cog,
            sog: data[i].sog,
            vmg: data[i].vmg,
            tcc: data[i].tcc
            // TODO completa tutte le informazioni
          });
      }  
    }

    // Ordinamento lista imbarcazioni
    // 0=Nessuno, 1=Name, 2=Rank, 3= Last message
    switch (this.boatLeaderBoardOrderType) {
      case 1 : // Name
        // this.boatsLeaderBoards.sort((a,b)=>{return (a.name.localeCompare(b.name))});
        this.boatsLeaderBoards.sort((a,b)=>{
            // return (a.name.localeCompare(b.name))
            // Nuovo ordinamento con classe "MARKER" sempre ultima
            if ((a.class=="MARKER") && (b.class!="MARKER"))
              return 1
            else if ((a.class!="MARKER") && (b.class=="MARKER"))
              return -1
            else
              return (a.name.localeCompare(b.name))
        });
        this.boatLeaderBoardOrderTypeText = "Order number by name";
      break;
      case 2 : // Rank - DTG (Distance to arrival)
        this.boatLeaderBoardOrderTypeText = "Rank by distance to arrival";
        this.boatsLeaderBoards.sort((a,b)=>{
          // TODO ATTENZIONE per adesso calcolo rank su sola distanza
          // Nuovo ordinamento con classe "MARKER" sempre ultima
          if ((a.class=="MARKER") && (b.class!="MARKER"))
            return 1
          else if ((a.class!="MARKER") && (b.class=="MARKER"))
            return -1
          else {
            // Se lo stato navigazione è inferiore a 50 (=navigazione) allora sbatto in fondo alla classifica !
            if ((a.nav_status <50) && (b.nav_status >=50)) 
              return 1;
            else if ((a.nav_status >=50) && (b.nav_status <50))
              return -1;
            else if ((a.nav_status <50)&&(b.nav_status <50))
            {
              return 0;
            }
            else if ((a.nav_status ==100)&&(b.nav_status ==100))
            {
              // Se entrambe le barche sono arrivate ordino comunque per data arrivo
              if (a.nav_toa_epoch > b.nav_toa_epoch)
                return 1;
              else
                return -1;
            }
            else if (a.nav_dtg_tot > b.nav_dtg_tot )
              return 1 
            else
              return -1 
          }  
        });
      break;
      case 3 : // Rank - ETA (Estimated arrival) 
        this.boatLeaderBoardOrderTypeText = "Rank by estimated arrival";
        this.boatsLeaderBoards.sort((a,b)=>{
          // Devo confrontare la data di arrivo effettiva oppure stimata
          // Nuovo ordinamento con classe "MARKER" sempre ultima
          if ((a.class=="MARKER") && (b.class!="MARKER"))
            return 1
          else if ((a.class!="MARKER") && (b.class=="MARKER"))
            return -1
          else {
              let a_eta;
              if (a.nav_status < 50)
                a_eta = this.trackingEndEpoch;    
              if (a.nav_status == 50)
                a_eta = a.nav_eta_epoch;    
              else if (a.nav_status==100)
                a_eta = a.nav_toa_epoch;    
              
              let b_eta;
              if (b.nav_status < 50)
                b_eta = this.trackingEndEpoch;    
              if (b.nav_status == 50)
                b_eta = b.nav_eta_epoch;    
              else if (b.nav_status==100)
                b_eta = b.nav_toa_epoch;    
              
              if ((a.nav_status <50) && (b.nav_status >=50)) 
                return 1;
              else if ((a.nav_status >=50) && (b.nav_status <50))
                return -1;
              else if ((a.nav_status <50)&&(b.nav_status <50))
              {
                return (a.name.localeCompare(b.name));
              }
              else 
              {
                if (a_eta == b_eta) 
                  return (a.name.localeCompare(b.name)); // Potrebbe capitare se vmg < 0 assegno tempo arrivo per fine evento (trackingEnd) !
                else if (a_eta > b_eta )
                  return 1 
                else
                  return -1 
              }
            } // Buoy     
        });
      break;
      case 4 : // Rank - ETA (Estimated arrival)  x TCC (compensated)
        this.boatLeaderBoardOrderTypeText = "Rank by estimated arrival TCC";
        this.boatsLeaderBoards.sort((a,b)=>{
          // Nuovo ordinamento con classe "MARKER" sempre ultima
          if ((a.class=="MARKER") && (b.class!="MARKER"))
            return 1
          else if ((a.class!="MARKER") && (b.class=="MARKER"))
            return -1
          else {
            // Devo confrontare il tempo di arrivo effettivo oppure stimato
            let a_eta;
            if (a.nav_status < 50)
              a_eta = this.trackingEndEpoch;    
            if (a.nav_status == 50)
              a_eta = a.nav_eta_epoch;    
            else if (a.nav_status==100)
              a_eta = a.nav_toa_epoch;    

            let b_eta;
            if (b.nav_status < 50)
              b_eta = this.trackingEndEpoch;    
            if (b.nav_status == 50)
              b_eta = b.nav_eta_epoch;    
            else if (b.nav_status==100)
              b_eta = b.nav_toa_epoch;    
            
            if ((a.nav_status <50) && (b.nav_status >=50)) 
              return 1;
            else if ((a.nav_status >=50) && (b.nav_status <50))
              return -1;
            else if ((a.nav_status <50)&&(b.nav_status <50))
            {
              return (a.name.localeCompare(b.name));
            }
            else 
            {
            if ((a_eta * a.tcc) == (b_eta * b.tcc)) 
              return (a.name.localeCompare(b.name));
            else if ((a_eta-this.trackingBeginEpoch) * a.tcc > ((b_eta-this.trackingBeginEpoch) * b.tcc ))
              return 1 
            else
              return -1 
            // else if (a_eta * a.tcc > b_eta * b.tcc )
            //   return 1 
            // else
            //   return -1 
            }  
          } // Buoy    
        });
      break;
      case 5 : // Speed to destination (VMG)
        this.boatLeaderBoardOrderTypeText = "Order by speed to destination";
        this.boatsLeaderBoards.sort((a,b)=>{
          // Nuovo ordinamento con classe "MARKER" sempre ultima  
          if ((a.class=="MARKER") && (b.class!="MARKER"))
            return 1
          else if ((a.class!="MARKER") && (b.class=="MARKER"))
            return -1
          else {
            if (a.vmg < b.vmg )
              return 1 
            else
              return -1 
          } // Buoy   
        });
      break;
      case 6 : // Last message received
        this.boatLeaderBoardOrderTypeText = "Order number by last message";
        this.boatsLeaderBoards.sort((a,b)=>{
          // Nuovo ordinamento con classe "MARKER" sempre ultima  
          if ((a.class=="MARKER") && (b.class!="MARKER"))
            return 1
          else if ((a.class!="MARKER") && (b.class=="MARKER"))
            return -1
          else {
            if (a.last_msg_epoch < b.last_msg_epoch )
              return 1 
            else
              return -1 
          }  
      });
      break;
      default:   
    } 

    // Notifico cambiamento della sola leaderboard a tutti gli iscritti
    // Nota che app.component ascolta questo evento per aggiornare disegno mappa !!!
    // SE la leaderboard cambia la mappa si aggiorna anche senza dati cambiati
    this._boatsLeaderBoards.next(this.boatsLeaderBoards);

  } 
  //---------------------------------------------------------------------------
  changeLeaderboardOrder(value) {
    // Quando cambia la selezione ordinamento leaderboard devo ricostruirla
    // La funzione updateBoatLeaderBoards() usa RXJS e subscriber per notificare le modifiche
    this.boatLeaderBoardOrderType = value;
    this.updateBoatLeaderBoards(this.boats);
    // console.log(value);
  }
  //---------------------------------------------------------------------------
  changeLeaderboardFilter(value) {
    // Quando cambia  il filtro leaderboard devo ricostruirla
    // La funzione updateBoatLeaderBoards() usa RXJS e subscriber per notificare le modifiche
    this.boatLeaderBoardFilterValue = value;
    this.updateBoatLeaderBoards(this.boats);
    // console.log(value);
  }
  //---------------------------------------------------------------------------
  distanceHaversine(lat1, lon1, lat2, lon2, unit) {
    // Trovata su internet, la funzione nativa leaflet L.LatLng.distanceTo() non riesco ad usarla perchè oggetto leaflet
    // non accessibile
    var radlat1 = Math.PI * lat1/180;
    var radlat2 = Math.PI * lat2/180;
    var radlon1 = Math.PI * lon1/180;
    var radlon2 = Math.PI * lon2/180;
    var theta = lon1-lon2;
    var radtheta = Math.PI * theta/180;
    var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    dist = Math.acos(dist);
    dist = dist * 180/Math.PI;
    dist = dist * 60 * 1.1515;
    if (unit=="K") { dist = dist * 1.609344 };
    if (unit=="N") { dist = dist * 0.8684 };
    return dist
  }
  //---------------------------------------------------------------------------
	playbackSpeedChange() {
    if (this.playbackSpeed==1)
      this.playbackSpeed=2;
    else if (this.playbackSpeed==2)  
      this.playbackSpeed=5;
    else if (this.playbackSpeed==5)  
      this.playbackSpeed=10;
    else if (this.playbackSpeed==10)  
      this.playbackSpeed=1;
  }
  //---------------------------------------------------------------------------
  playbackEpochChange(epoch:number) {
    this.playbackEpoch = epoch;
    this.playbackDateTime = moment.unix(this.playbackEpoch).format("DD/MM/YY HH:mm");
    
    if (this.playbackActive == false)
      this.processBoatsDataAndBroadcast(this.boatsCache);   // Invio i dati completi per elaborazione
    
    // console.log("playBackRangeInput::this.api.playbackEpoch="+this.playbackEpoch);
  }
  //---------------------------------------------------------------------------
}
